import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import TrackPaymentsFigure from "../../../../assets/images/payments/track-your-payments.png";
import SimplifyCustomerManagementFigure from "../../../../assets/images/payments/simplify-customer-management.png";
import BoostPerformanceFigure from "../../../../assets/images/payments/boost-performance.png";

const WhyUsePaymentLinks = () => {
  const { t } = useTranslation();

  const sectionList = [
    {
      title: t("pages.payment.overview.trackPayments"),
      subTitle: t("pages.payment.overview.stayOnTopOfYourFinance"),
      img: TrackPaymentsFigure,
    },
    {
      title: t("pages.payment.overview.simplifyCustomerManagement"),
      subTitle: t("pages.payment.overview.easilyAccessCustomerDetails"),
      img: SimplifyCustomerManagementFigure,
    },
    {
      title: t("pages.payment.overview.boostPerformance"),
      subTitle: t("pages.payment.overview.analyzeKeyMetrics"),
      img: BoostPerformanceFigure,
    },
  ];

  return (
    <Box sx={{ display: "flex", flexDirection: "column" }}>
      <Typography
        component="p"
        sx={{
          color: "#111",
          fontFamily: "Montserrat",
          fontSize: "14px",
          fontStyle: "normal",
          fontWeight: 400,
          lineHeight: "20px",
          marginBottom: "16px",
        }}
      >
        {t("pages.payment.overview.simplifyYourPayments")}
      </Typography>
      <Box
        component="ul"
        sx={{
          display: "flex",
          justifyContent: "space-between",
          margin: 0,
        }}
      >
        {sectionList.map(({ title, subTitle, img }, idx: number) => (
          <Box
            component="li"
            sx={{
              display: "flex",
              flexDirection: "column",
              rowGap: "32px",
              alignItems: "stretch",
              textAlign: "center",
              width: "calc(33% - 12px)",
            }}
          >
            <img src={img} style={{ maxWidth: "auto", height: "167px", objectFit: "cover" }} />
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                columnGap: "8px",
              }}
            >
              <Typography
                component="span"
                sx={{
                  color: "#101828",
                  fontFamily: "Montserrat",
                  fontSize: "18px",
                  fontStyle: "normal",
                  fontWeight: 600,
                  lineHeight: "28px",
                  maxWidth: "75%",
                }}
              >
                {title}
              </Typography>
              <Typography
                component="p"
                sx={{
                  color: "#475467",
                  fontFamily: "Montserrat",
                  fontSize: "14px",
                  fontStyle: "normal",
                  fontWeight: 400,
                  lineHeight: "20px",
                }}
              >
                {subTitle}
              </Typography>
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default WhyUsePaymentLinks;
